import { ISorting } from '..';
import { Table, TableBody, TableHeading, TableHeadingCol, TableRow } from '../../../../components/Table';
import { LPlan } from '../../../../interfaces/Plan';
import { TableRowItem } from './TableRowItem';
import { BiSort } from 'react-icons/bi';
interface Props {
  data: LPlan[];
  handleSort?: (key: ISorting) => void;
}

export default function TableContainer({ data, handleSort }: Props) {
  return (
    <div className="w-full min-h-[500px] overflow-x-scroll custom-scrollbar font-medium">
      <Table>
        <TableHeading>
          <TableRow>
            <TableHeadingCol
              onClick={() => handleSort && handleSort('createdAt')}
              label="Date"
              component={
                <div className="flex items-center">
                  <p className="">Date</p>
                  <BiSort className="text-sm" />
                </div>
              }
            />
            <TableHeadingCol label="Req ID" />
            <TableHeadingCol
              label="NAME"
              onClick={() => handleSort && handleSort('studentName')}
              component={
                <div className="flex items-center">
                  <p className="">Name</p>
                  <BiSort className="text-sm" />
                </div>
              }
            />
            <TableHeadingCol label="EMAIL" />
            <TableHeadingCol label="PHONE NO." />
            <TableHeadingCol label="CLASSES" />
            <TableHeadingCol label="STATUS" />
          </TableRow>
        </TableHeading>
        <TableBody>
          {data.map((plan) => (
            <TableRow key={plan._id}>
              <TableRowItem plan={plan} />
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  );
}
